import WebLayout from "../../../layout/WebLayout";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import POProductAction from "../../../stores/actions/POProductAction";
import { RootState } from "../../../stores";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import OrderItemsModel from "../../../components/OrderItemsModel";
import { INDIAN_MSME_USER_TYPE } from "../../../utils/Constants";
import { storeCookie } from "../../../utils/CookieAction";

function POList() {
  const routeParams = useParams();
  const poOrderStatus = routeParams.poOrderStatus;

  let status = "";
  let name = "";

  const dispatch = useDispatch<any>();

  let total = 0;
  let totalTax = 0;
  const { poList } = useSelector((state: RootState) => state.po_product);
  const { profileDetails } = useSelector((state: RootState) => state.auth);

  if (poOrderStatus === "requested") {
    status = "REQUESTED";
  } else if (poOrderStatus === "accepted") {
    status = "ACCEPTED";
  } else if (poOrderStatus === "rejected") {
    status = "REJECTED";
  }

  if (poOrderStatus === "requested") {
    name = "Order Placement";
  } else if (poOrderStatus === "accepted") {
    name = "Order Payment";
  } else if (poOrderStatus === "rejected") {
    name = "Rejected List";
  }

  const getPOList = useCallback(async () => {
    await dispatch(
      POProductAction.getPOList({
        poOrderStatus: status,
      })
    );
  }, [dispatch, status]);

  useEffect(() => {
    getPOList();
  }, [getPOList, status]);

  return (
    <WebLayout pageName={"POList"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center pb-2">
              <h4 className="card-title">{name}</h4>
            </div>
            <div className="table-responsive text-nowrap">
              <table className="table text-center table-bordered">
                <thead>
                  <tr>
                    <th>SN.</th>
                    <th>Order Id</th>
                    <th>Order Date</th>
                    <th>Price</th>

                    <th>Quantity</th>
                    <th>Order Items</th>
                    {poOrderStatus === "requested" ? (
                      ""
                    ) : poOrderStatus === "rejected" ? (
                      ""
                    ) : (
                      <th>Pay</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {poList?.length > 0 ? (
                    poList.map((orderDataList: any, index: number) => {
                      total = Number(orderDataList.price);
                      totalTax =
                        Number(orderDataList.totalSellerTax) +
                        Number(orderDataList.totalCompanyTax);
                      return (
                        <tr key={orderDataList.id}>
                          <td>{index + 1}</td>
                          <td>#{orderDataList.order_generate_id}</td>
                          <td>
                            {moment(orderDataList.created_at).format("lll")}
                          </td>
                          <td>Rs. {orderDataList.price}</td>

                          <td>{orderDataList.qty}</td>
                          <td>
                            <OrderItemsModel
                              data={orderDataList?.items}
                              userType={profileDetails?.user_type}
                            />
                          </td>
                          {orderDataList.po_order_status === "ACCEPTED" ? (
                            <td>
                              <Link
                                to={`/payment/${orderDataList.id}/${window.btoa(
                                  JSON.stringify({ amount: total })
                                )}`}>
                                <button className={"btn btn-primary btn-sm"}>
                                  Proceed to Pay
                                </button>
                              </Link>
                            </td>
                          ) : (
                            ""
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>No matching records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default POList;
